// extracted by mini-css-extract-plugin
export default {"menuList":"menu_menuList__ANpGs","menuItem":"menu_menuItem__mwQkT"};